module.exports = __webpack_public_path__ + "img/mise en place pergola.55ff395c.jpg";